/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useCallback, useRef, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";

const portalTooltipStyle = css`
  background: var(--color-gray-800);
  color: var(--color-background);
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  font-size: 0.6875rem;
  font-weight: 400;
  box-shadow: var(--shadow-md);
  pointer-events: none;
  position: fixed;
  z-index: 99999;
  white-space: nowrap;
  transition: opacity 0.1s;
`;

export function PortalTooltip({ text, children }: { text: string; children: ReactNode }) {
  const ref = useRef<HTMLSpanElement>(null);
  const [pos, setPos] = useState<{ top: number; left: number } | null>(null);
  const show = useCallback(() => {
    if (!ref.current) return;
    const r = ref.current.getBoundingClientRect();
    setPos({ top: r.top + r.height / 2, left: r.right + 10 });
  }, []);
  const hide = useCallback(() => setPos(null), []);
  return (
    <span ref={ref} onMouseEnter={show} onMouseLeave={hide} style={{ display: "inline-flex" }}>
      {children}
      {pos &&
        createPortal(
          <div css={portalTooltipStyle} style={{ top: pos.top, left: pos.left, transform: "translateY(-50%)" }}>
            {text}
          </div>,
          document.body,
        )}
    </span>
  );
}
